import defaultAttributes from '../defaultAttributes';

const StretchHorizontal = [
  'svg',
  defaultAttributes,
  [
    ['rect', { x: '2', y: '4', width: '20', height: '6', rx: '2' }],
    ['rect', { x: '2', y: '14', width: '20', height: '6', rx: '2' }],
  ],
];

export default StretchHorizontal;
